export default __webpack_public_path__ + "static/media/photo1.84be1b4c.png";